import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { UiModal } from 'shared/ui';

import { CarDto } from 'entities/car';

import { EditCar } from '../edit';

type Props = {
  car: CarDto;
  personLogin: string;
};

export const EditCarModal = NiceModal.create((props: Props) => {
  const modal = useModal();

  return (
    <UiModal
      title="Редактировать автомобиль"
      visible={modal.visible}
      onCancel={modal.hide}
      afterClose={modal.remove}
    >
      <EditCar {...props} closeModal={modal.hide} />
    </UiModal>
  );
});
